const baseUrl = process.env.REACT_APP_ACCOUNT_SERVER_BASE_URL;

export const integrationsUrl = `${baseUrl}/integrations`;
export const integrationServiceUrl = `${baseUrl}/integration-services`;
export const permissionsUrl = `${baseUrl}/permissions`;
export const touUrl = `${baseUrl}/tou`;
